module.exports = __webpack_public_path__ + "img/logo3.e10785cf.png";